/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { hotelActions } from './slice';
import API from './constants';
/**
 * Get hotel generator function to obtain registered hotels
 * @param {*} param0
 */
export function* getHotelsGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_HOTELS, payload);
    yield put(hotelActions.getHotelsSucceeded(response));
  } catch (error) {
    yield put(hotelActions.getHotelsFailed(error?.message));
  }
}
/**
 * Create hotel generator function to create hotel
 * @param {*} param0
 */
export function* createHotelGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_HOTEL, payload);
    yield put(hotelActions.createHotelSucceeded(response));
  } catch (error) {
    yield put(hotelActions.createHotelFailed(error?.message));
  }
}
/**
 * Delete hotel function to delete hotel
 * @param {*} param0
 */
export function* deleteHotelGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_HOTEL, payload);
    yield put(hotelActions.deleteHotelSucceeded({ response, data: payload }));
  } catch (error) {
    yield put(hotelActions.deleteHotelFailed(error?.message));
  }
}
/**
 * Update hotel generator function to update hotel
 * @param {*} param0
 */
export function* updateHotelGenerator({ payload }) {
  try {
    const response = yield call(request, API.PATCH_HOTEL, payload);
    yield put(hotelActions.updateHotelSucceeded(response));
  } catch (error) {
    yield put(hotelActions.updateHotelFailed(error?.message));
  }
}
/**
 * Get currency  generator function to obtain currency data
 * @param {*} param0
 */
export function* getCurrencyDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_CURRENCY_DATA, payload);
    yield put(hotelActions.getCurrencyDataSucceeded(response));
  } catch (error) {
    yield put(hotelActions.getCurrencyDataFailed(error?.message));
  }
}
/**
 * Get users assigned to hotel  generator function to obtain list of users assigned to each hotel
 * @param {*} param0
 */
export function* getUsersAssignedToHotel({ payload }) {
  try {
    const response = yield call(request, API.GET_HOTEL_USER_DATA, payload);
    yield put(hotelActions.getHotelUserDataSucceeded(response));
  } catch (error) {
    yield put(hotelActions.getHotelUserDataFailed(error?.message));
  }
}

//
export function* hotelSaga() {
  yield takeLatest(hotelActions.getHotels.type, getHotelsGenerator);
  yield takeLatest(hotelActions.createHotel.type, createHotelGenerator);
  yield takeLatest(hotelActions.deleteHotel.type, deleteHotelGenerator);
  yield takeLatest(hotelActions.updateHotel.type, updateHotelGenerator);
  yield takeLatest(hotelActions.getCurrencyData.type, getCurrencyDataGenerator);
  yield takeLatest(hotelActions.getHotelUserData.type, getUsersAssignedToHotel);
}
//
export default hotelSaga;
